import {useCallback,useEffect,useRef,useState} from 'react';
import {prepareOfflineDictionary} from './prepare';
export default function useOfflinePreparation(){
 const [ready,setReady]=useState(false),[error,setError]=useState('');
 const live=useRef(false),flight=useRef(null);
 const retry=useCallback(()=>{
  if(flight.current)return flight.current;
  setError('');
  flight.current=prepareOfflineDictionary().then(value=>{
   if(!live.current)return;
   if(!value?.words?.length)throw Error('Sözlük hazır değil.');
   setReady(true);
  }).catch(()=>{if(live.current)setError('Sözlük hazırlanamadı. Bağlantını ve cihazdaki boş alanı kontrol edip yeniden dene.');}).finally(()=>{flight.current=null;});
  return flight.current;
 },[]);
 useEffect(()=>{live.current=true;retry();window.addEventListener('online',retry);navigator.serviceWorker?.addEventListener('controllerchange',retry);return()=>{live.current=false;window.removeEventListener('online',retry);navigator.serviceWorker?.removeEventListener('controllerchange',retry);};},[retry]);
 return {ready,error,retry};
}
